import { Query, Mutation } from "react-apollo";
import { Redirect } from "react-router";
import gql from "graphql-tag";
import React from "react";

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  };

  render() {
    return (
      <div className="row no-sidebar">
        <div className="col-md-5 col-lg-4 mx-auto">
          <h3>Login</h3>
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              const res = await this.props.login({
                variables: {
                  email: this.state.email,
                  password: this.state.password,
                  deviceType: "desktop",
                  ip: "0.0.0.0",
                },
              });
              if (res.data.login.response.payload !== "success") {
                alert("Invalid username or password.");
                this.setState({
                  password: "",
                });
              }
              window.location.replace("/admin");
            }}
          >
            <div className="form-group">
              <label>Email</label>
              <input
                onChange={this.handleInputChange}
                value={this.state.email}
                name="email"
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Email"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                onChange={this.handleInputChange}
                value={this.state.password}
                type="password"
                className="form-control"
                name="password"
                id="password"
                placeholder="Password"
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </form>
        </div>
      </div>
    );
  }
}

const GET_VIEWER = gql`
  query getViewer {
    viewer {
      id
      isUserAuthenticated
      specialPermissions {
        isAdmin
      }
    }
  }
`;

const LOGIN = gql`
  mutation LOGIN($email: String!, $password: String!, $deviceType: String!) {
    login(email: $email, password: $password, deviceType: $deviceType) {
      id
      response {
        payload
        message
      }
      userId
      email
      name
      isUserAuthenticated
      specialPermissions {
        isAdmin
      }
    }
  }
`;

const loginWithData = (props) => (
  <Query query={GET_VIEWER}>
    {({ loading, error, data }) => {
      if (loading) return "Loading...";
      if (error) return `Error! ${error.message}`;

      let isAdmin = false;

      if (data.viewer.specialPermissions) {
        isAdmin = data.viewer.specialPermissions.isAdmin;
      }

      if (data.viewer.isUserAuthenticated && isAdmin) {
        return <Redirect to="/" />;
      }

      return (
        <Mutation mutation={LOGIN}>
          {(login) => {
            return <Login login={login} {...props} />;
          }}
        </Mutation>
      );
    }}
  </Query>
);

export default loginWithData;
